import { Collapsible } from '../interfaces';
import { Currency } from './currency';
import { Language } from './language';
import { InternalLocalFileReportInstanceStatus } from './internal-local-file-report-instance-status';

export class InternalLocalFileReportInstance implements Collapsible {
  internalLocalfileReportInstanceId: number;
  version: number;
  status?: InternalLocalFileReportInstanceStatus;
  reportStage: string;
  createdAt: string;
  customerVersionFlag: number;
  finalVersionFlag: number;
  collapsed: boolean;
  reportCurrency: Currency;
  reportLanguage: Language;
  executiveSummaryConclusion: string;
  executiveSummaryIntro: string;
  languageIso: string;
  isUploadedReport: number;
  binaryPath: string;
}
